import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import {handleOnChange} from '../../customActions';
import InputWithAutosuggestSlider from './InputWithAutosuggestSlider';

function InputWithAutoSuggest(props) {
    const { 
        parentIndex,
        item,
        handleOnChange,
        isSellOnline
    } = props; 
    const {
        s_id,
        s_dnm,
        s_type_options,
        userInput,
        s_mandatory,
        s_re_mandatory
    } = item;
    const [suggestionOptions, setSuggestionOptions] = useState([])

    const loopKey = `${ s_dnm }-${ s_id }-${parentIndex}`;  
    const customHandleChange = (value="", ignoreValidation = false) => {
        handleOnChange({ 
            e: {
                target: {
                    value
                }
            },
            item, 
            parentIndex,
            isSellOnline,
            ignoreValidation
        })
    }
    return (<InputWithAutosuggestSlider 
                sliderHeading={s_dnm}
                key={loopKey}
                label={s_dnm || "Title"}
                input={{
                    value: userInput.value || "",
                    type: 'text',
                    name:`${ s_dnm }-${ s_id }`,
                    autoFocus: false,
                    onChange: (e) => {},
                    readOnly: true
                }}
                errorMessage={userInput.error} 
                infoMessage={!userInput.error && (props.showSellOnline ? s_mandatory =='1' : s_re_mandatory == '1') && !props.isAuditor ? 'Required Field':''}
                suggestions={s_type_options.map((s_item, s_index)=> {
                    return {key: s_index ,value: s_item }
                })}
                onSelect={(res) => customHandleChange(res.value)}
                onRightIconClick={() => customHandleChange('',true)}
                crossIcon={true}
            />)
} 
 
const mapStateToProps = (state, props) => {
    return {
        ...props, 
        item: state.productSpecification.editablePuvSpecAttributes[props.parentIndex],
        isSellOnline: state.products.editProduct.isSellOnline || props.showSellOnline,
        isService: state.products.editProduct.categoryType == 'service',
        isAuditor: state.session?.user?.loggedUser?.userType == "AUDITOR"
    }
};

const mapDispatchToProps = dispatch => ({
    handleOnChange: (options) =>  dispatch(handleOnChange(options, dispatch))
});
 

export default connect(mapStateToProps, mapDispatchToProps)(InputWithAutoSuggest);